import type { LucideIcon } from 'lucide-react';

export function ValueCard({ icon: Icon, title, description }: { icon: LucideIcon; title: string; description: string }) {
  return (
    <article className="h-full rounded-[1.35rem] border border-forest/10 bg-white p-5 shadow-soft transition hover:-translate-y-1 hover:shadow-soft sm:rounded-[1.25rem] sm:p-6">
      <div className="grid h-11 w-11 place-items-center rounded-2xl bg-gradient-to-br from-tint to-[#fff4c9] text-forest sm:h-12 sm:w-12">
        <Icon className="h-5 w-5 sm:h-6 sm:w-6" />
      </div>
      <h3 className="mt-4 text-lg font-black text-ink sm:mt-5 sm:text-xl">{title}</h3>
      <p className="mt-3 text-sm leading-6 text-charcoal/70 sm:text-base sm:leading-7">{description}</p>
    </article>
  );
}
